module.exports = __webpack_public_path__ + "static/media/log-out.a840fde4.svg";